import { store } from "@/store"
import User from "@/types/User.interface"

/**
 * Report user to profitwell
 * 
 * @param {User} user 
 */
 const profitwellStart = (user: User): void => {
    //  If the user does NOT have a stripe id, do nothing
    if (!user.stripe_customer_id) return

    //  Else, report the user to profitwell
    window.profitwell('start', { 'user_id': user.stripe_customer_id })
}

export default {
    //  Handles the UserLogin event
    onUserLogin(user: User): void {
        store.getters.appDebug && console.log('ProfitWell: onUserLogin')
        
        //  Register the user in profitwell
        profitwellStart(user)
    }
}
